import type { FC, ReactNode } from 'react';
import { Box } from '@mui/material';

interface Props {
  children?: ReactNode;
  index: Number;
  value: Number;
}

const TabPanel: FC<React.PropsWithChildren<Props>> = ({ children, value, index, ...other }) => {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} {...other}>
      <Box>{children}</Box>
    </div>
  );
};

export default TabPanel;
